import Button from '$store/components/ui/Button.tsx'
import Icon from '$store/components/ui/Icon.tsx'
import { useUI } from '$store/sdk/useUI.ts'

export interface Props {
    type?: 'close' | 'open'
}

export default function MenuButton({ type = 'open' }) {
    const { displayMenu } = useUI()

    return (
        <Button
            class='btn btn-circle btn-sm btn-ghost'
            aria-label='Abrir menu'
            onClick={() => {
                displayMenu.value = type === 'open'
            }}
        >
            <Icon
                id={type === 'open' ? 'Bars3' : 'XMark'}
                height={23}
                width={23}
                strokeWidth={0.01}
            />
        </Button>
    )
}
